import React from "react";
import { Container } from "./styles";

const Input = ({
  label,
  value,
  description,
  setValue,
  error,
  height,
  ...otherProps
}) => {
  return (
    <Container marginBottom={!description} height={height}>
      {label && <label>{label}</label>}
      {description && <p>{description}</p>}
      <input
        type={otherProps?.type || "text"}
        value={value}
        onChange={({ target }) => setValue(target.value)}
        {...otherProps}
      />
      {error && <span>{error}</span>}
    </Container>
  );
};

export default Input;
